
import HotBlockList from '@/components/common/HotBlockList.vue';
import { Icon } from '@atom/atom-ui';
import '@atom/atom-ui/lib/icon/style';
import '@atom/atom-icons/icons/arrow-right';
import { Component, Vue } from 'vue-property-decorator';
import { statClick } from '@/config/stat';
import { pushBy2804 } from '@/utils/tools';
import { DEFAULT_HOT_BLOCK_TAB } from '@/config/config';

@Component({
  components: {
    [Icon.name]: Icon,
    HotBlockList,
  },
})
export default class HotBlockCard extends Vue {
  activeTag = DEFAULT_HOT_BLOCK_TAB;

  jumpMore() {
    pushBy2804('/hotBlock', { tab: this.activeTag });
    statClick('ths_mob_yanbao_hotBlock_ckgd1');
  }

  handleTabChange(name) {
    this.activeTag = name;
  }
}
